export const translate = (key) => window.__litium.translation[key] || key
export const translateWithFallback = (key, fallback) =>
    window.__litium.translation[key] || fallback || key
